import React, { memo } from 'react';

import { FlightsTable } from 'components/Pages/Admin/GuestPortal/Flights/FlightsTable';
import { tableWrapperPDF } from 'components/Pages/Admin/GuestPortal/Flights/FlightsTable/index.module.css';
import useElementSize from 'hooks/useElementSize';
import i18n from 'i18n';

import { useLayoutHeight } from '../../functions';
import OrdinaryPage from '../../Templates/OrdinaryPage';
import { useRelocationsPage } from './functions';

function Relocations({ onReady }) {
  const { innerPages, showCondition, handleFailureHandler, handleReady, dateFormat } = useRelocationsPage({
    onReady,
  });

  if (showCondition) {
    return null;
  }

  return (
    <>
      {innerPages.map((p, i) => (
        <MemoizedRecursiveRelocationsPage
          key={i}
          blocks={p}
          onFail={handleFailureHandler}
          onReady={handleReady}
          isLastPage={i === innerPages.length - 1}
          tableSubtitle={i18n.t('proposal_content.guest_portal.flight_and_transfers_page.details')}
          dateFormat={dateFormat}
        />
      ))}
    </>
  );
}

export default Relocations;

function BlocksTarget({ blocks = [], onReady, onFail, isLastPage, size, dateFormat }) {
  const spaceRef = useLayoutHeight({
    maxHeight: size.height - 170,
    ignore: !isLastPage,
    blocks,
    onReady,
    onFail: () => onFail(blocks),
  });

  return (
    <div ref={spaceRef}>
      <FlightsTable.Wrapper wrapperClassName={tableWrapperPDF}>
        <FlightsTable.Table>
          <FlightsTable.Head withoutMenu isReadonly />
          <FlightsTable.Body>
            <FlightsTable.List isReadonly collection={blocks} withoutMenu isPDF dateFormat={dateFormat} />
          </FlightsTable.Body>
        </FlightsTable.Table>
      </FlightsTable.Wrapper>
    </div>
  );
}

function RecursiveManifestPage(props) {
  const { blocks = [], tableSubtitle } = props;
  const pageSubtitle = blocks.length > 0 ? tableSubtitle : undefined;
  const [containerRef, containerSize] = useElementSize();

  return (
    <OrdinaryPage title="Flights & Transfers" subtitle={pageSubtitle}>
      <div style={{ height: 850, flex: 1 }} ref={containerRef}>
        <BlocksTarget {...props} size={containerSize} />
      </div>
    </OrdinaryPage>
  );
}

const MemoizedRecursiveRelocationsPage = memo(
  RecursiveManifestPage,
  (prev, next) => prev.blocks.length === next.blocks.length,
);
